"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.TransitionVisitor = void 0;
class TransitionVisitor {
    stopRequested = false;
    visitQuestionnaire(questionnaire) {
        if (questionnaire?.length > 0) {
            for (const sectionGroup of questionnaire) {
                if (this.stopRequested)
                    break;
                this.visitSectionGroup(sectionGroup);
            }
        }
    }
    visitSectionGroup(sectionGroup) {
        if (sectionGroup.sections?.length > 0) {
            for (const section of sectionGroup.sections) {
                if (this.stopRequested)
                    break;
                this.visitSection(section);
            }
        }
    }
    visitSection(section) {
        if (section.subsections?.length > 0) {
            for (const subsection of section.subsections) {
                if (this.stopRequested)
                    break;
                this.visitSubsection(subsection);
            }
        }
    }
    visitSubsection(subsection) {
        if (subsection.fieldGroups?.length > 0) {
            for (const fieldGroup of subsection.fieldGroups) {
                if (this.stopRequested)
                    break;
                this.visitFieldGroup(fieldGroup);
            }
        }
    }
    visitFieldGroup(fieldGroup) {
        if (fieldGroup.fields?.length > 0) {
            for (const field of fieldGroup.fields) {
                if (this.stopRequested)
                    break;
                this.visitField(field);
            }
        }
    }
    visitField(field) {
        if (field.options?.length > 0) {
            for (const option of field.options) {
                if (this.stopRequested)
                    break;
                this.visitOption(option);
            }
        }
    }
    // eslint-disable-next-line @typescript-eslint/no-unused-vars
    visitOption(option) { }
    stopVisit = () => {
        this.stopRequested = true;
    };
}
exports.TransitionVisitor = TransitionVisitor;
